import { ExpertiseWidgetStrategy } from '../ExpertiseWidgetStrategy';
import { columnDefs } from './expertiseDnaColumns';
import { WidgetType } from 'widgets/WidgetType';
import { expertiseWidgetStrategyCommon } from 'widgets/expertise/expertiseWidgetStrategyCommon';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { streamConfig } from 'widgets/expertise/store/stream/stream-config';
import Expertise from 'widgets/expertise/Expertise';

export const expertiseDnaWidgetStrategy: ExpertiseWidgetStrategy = {
    title: 'Expertise Dna',
    reactComponentType: Expertise,
    reportType: 'DNA',
    buildColumnDefs: columnDefs,
    categories: [WidgetCategory.SINGLE_STOCK],
    streamConfigs: [streamConfig(WidgetType.EXPERTISE_DNA, 'DNA')],
    ...expertiseWidgetStrategyCommon,
};
